import React, { useState, useEffect, Fragment, useRef } from "react"
import { operationsHelper } from "../../helpers/operations"

const MetadataLayoutDetails = ({ documentMetadata, item, maskHightlight }) => {
	switch (item.source) {
		case "email":
			return (
				<Fragment>
					<p className="mb-5px">
						<strong>Type:</strong>
						<span dangerouslySetInnerHTML={operationsHelper.getDocumentType(item.source)}></span>
					</p>
					<p className="mb-5px">
						<strong>Subject:</strong>
						<p
							id="document_subject_div"
							dangerouslySetInnerHTML={
								documentMetadata.hasOwnProperty(item.id) && documentMetadata[item.id].hasOwnProperty("subject")
									? maskHightlight(documentMetadata[item.id]["subject"], item.id)
									: {
											__html: `
                                                                <div className="col-12 d-flex justify-content-center mt-5 mb-5">
                                                                    <div className="d-flex align-items-center alert alert-warning">
                                                                        <strong className="loading">Loading...</strong>
                                                                        <div className="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                                                                    </div>
                                                                </div>
                                                                `,
									  }
							}
						></p>
					</p>

					<p className="mb-5px">
						<strong>From:</strong>
						<p
							id="document_from_div"
							dangerouslySetInnerHTML={
								documentMetadata.hasOwnProperty(item.id) && documentMetadata[item.id].hasOwnProperty("from")
									? maskHightlight(documentMetadata[item.id]["from"], item.id)
									: {
											__html: `
                                                                <div className="col-12 d-flex justify-content-center mt-5 mb-5">
                                                                    <div className="d-flex align-items-center alert alert-warning">
                                                                        <strong className="loading">Loading...</strong>
                                                                        <div className="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                                                                    </div>
                                                                </div>
                                                                `,
									  }
							}
						></p>
					</p>

					<p className="mb-5px">
						<strong>To:</strong>
						<p
							id="document_to_div"
							dangerouslySetInnerHTML={
								documentMetadata.hasOwnProperty(item.id) && documentMetadata[item.id].hasOwnProperty("to")
									? maskHightlight(documentMetadata[item.id]["to"], item.id)
									: {
											__html: `
                                                                <div className="col-12 d-flex justify-content-center mt-5 mb-5">
                                                                    <div className="d-flex align-items-center alert alert-warning">
                                                                        <strong className="loading">Loading...</strong>
                                                                        <div className="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                                                                    </div>
                                                                </div>
                                                                `,
									  }
							}
						></p>
					</p>

					<p className="mb-5px">
						<strong>Date:</strong>{" "}
						<span>
							{documentMetadata.hasOwnProperty(item.id) && documentMetadata[item.id].hasOwnProperty("date")
								? // new Intl.DateTimeFormat('en-US', {
								  //     year: 'numeric',
								  //     month: 'long',
								  //     day: '2-digit'
								  // }).format(documentMetadata[item.id]['date'])

								  new Date(documentMetadata[item.id]["date"]).toLocaleString("en-US", {
										year: "numeric",
										month: "long",
										day: "2-digit",
								  })
								: ""}
						</span>
					</p>

					<p className="mb-5px">
						<strong>Content:</strong>{" "}
					</p>
				</Fragment>
			)
			break
		case "word":
		case "doc":
		case "docx":
			return (
				<Fragment>
					<p className="mb-5px">
						<strong>Type:</strong>
						<span dangerouslySetInnerHTML={operationsHelper.getDocumentType(item.source)}></span>
					</p>
					<p
						className="mb-5px"
						style={{
							display:
								documentMetadata.hasOwnProperty(item.id) &&
								documentMetadata[item.id].hasOwnProperty("author") &&
								documentMetadata[item.id]["author"] !== ""
									? "block"
									: "none",
						}}
					>
						<strong>Author:</strong>
						<p
							id="document_subject_div"
							dangerouslySetInnerHTML={
								documentMetadata.hasOwnProperty(item.id) && documentMetadata[item.id].hasOwnProperty("author")
									? maskHightlight(documentMetadata[item.id]["author"], item.id)
									: {
											__html: `
                                                                <div className="col-12 d-flex justify-content-center mt-5 mb-5">
                                                                    <div className="d-flex align-items-center alert alert-warning">
                                                                        <strong className="loading">Loading...</strong>
                                                                        <div className="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                                                                    </div>
                                                                </div>
                                                                `,
									  }
							}
						></p>
					</p>

					<p
						className="mb-5px"
						style={{
							display:
								documentMetadata.hasOwnProperty(item.id) &&
								documentMetadata[item.id].hasOwnProperty("filename") &&
								documentMetadata[item.id]["filename"] !== ""
									? "block"
									: "none",
						}}
					>
						<strong>File name:</strong>
						<p
							id="document_from_div"
							dangerouslySetInnerHTML={
								documentMetadata.hasOwnProperty(item.id) && documentMetadata[item.id].hasOwnProperty("filename")
									? maskHightlight(documentMetadata[item.id]["filename"], item.id)
									: {
											__html: `
                                                                <div className="col-12 d-flex justify-content-center mt-5 mb-5">
                                                                    <div className="d-flex align-items-center alert alert-warning">
                                                                        <strong className="loading">Loading...</strong>
                                                                        <div className="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                                                                    </div>
                                                                </div>
                                                                `,
									  }
							}
						></p>
					</p>

					<p
						className="mb-5px"
						style={{
							display:
								documentMetadata.hasOwnProperty(item.id) &&
								documentMetadata[item.id].hasOwnProperty("filepath") &&
								documentMetadata[item.id]["filepath"] !== ""
									? "block"
									: "none",
						}}
					>
						<strong>File path:</strong>
						<p
							id="document_to_div"
							dangerouslySetInnerHTML={
								documentMetadata.hasOwnProperty(item.id) && documentMetadata[item.id].hasOwnProperty("filepath")
									? maskHightlight(documentMetadata[item.id]["filepath"], item.id)
									: {
											__html: `
                                                                <div className="col-12 d-flex justify-content-center mt-5 mb-5">
                                                                    <div className="d-flex align-items-center alert alert-warning">
                                                                        <strong className="loading">Loading...</strong>
                                                                        <div className="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                                                                    </div>
                                                                </div>
                                                                `,
									  }
							}
						></p>
					</p>

					<p
						className="mb-5px"
						style={{
							display:
								documentMetadata.hasOwnProperty(item.id) &&
								documentMetadata[item.id]["date"] !== undefined &&
								documentMetadata[item.id]["date"] !== ""
									? "block"
									: "none",
						}}
					>
						<strong>Date:</strong>{" "}
						<span>
							{documentMetadata.hasOwnProperty(item.id) && documentMetadata[item.id].hasOwnProperty("date")
								? // new Intl.DateTimeFormat('en-US', {
								  //     year: 'numeric',
								  //     month: 'long',
								  //     day: '2-digit'
								  // }).format(documentMetadata[item.id]['date'])

								  new Date(documentMetadata[item.id]["date"]).toLocaleString("en-US", {
										year: "numeric",
										month: "long",
										day: "2-digit",
								  })
								: ""}
						</span>
					</p>

					{documentMetadata.hasOwnProperty(item.id) && documentMetadata[item.id].hasOwnProperty("category") ? (
						<p
							className="mb-5px"
							style={{
								display:
									documentMetadata.hasOwnProperty(item.id) &&
									documentMetadata[item.id].hasOwnProperty("category") &&
									documentMetadata[item.id]["category"] !== ""
										? "block"
										: "none",
							}}
						>
							<strong>Category:</strong>
							<p
								id="document_subject_div"
								dangerouslySetInnerHTML={maskHightlight(documentMetadata[item.id]["category"], item.idItem)}
							></p>
						</p>
					) : null}
					{documentMetadata.hasOwnProperty(item.id) && documentMetadata[item.id].hasOwnProperty("content_status") ? (
						<p
							className="mb-5px"
							style={{
								display:
									documentMetadata.hasOwnProperty(item.id) &&
									documentMetadata[item.id].hasOwnProperty("content_status") &&
									documentMetadata[item.id]["content_status"] !== ""
										? "block"
										: "none",
							}}
						>
							<strong>Content status:</strong>
							<p
								id="document_subject_div"
								dangerouslySetInnerHTML={maskHightlight(documentMetadata[item.id]["content_status"], item.idItem)}
							></p>
						</p>
					) : null}
					{documentMetadata.hasOwnProperty(item.id) && documentMetadata[item.id].hasOwnProperty("identifier") ? (
						<p
							className="mb-5px"
							style={{
								display:
									documentMetadata.hasOwnProperty(item.id) &&
									documentMetadata[item.id].hasOwnProperty("identifier") &&
									documentMetadata[item.id]["identifier"] !== ""
										? "block"
										: "none",
							}}
						>
							<strong>Identifier:</strong>
							<p
								id="document_subject_div"
								dangerouslySetInnerHTML={maskHightlight(documentMetadata[item.id]["identifier"], item.idItem)}
							></p>
						</p>
					) : null}
					{documentMetadata.hasOwnProperty(item.id) && documentMetadata[item.id].hasOwnProperty("keywords") ? (
						<p
							className="mb-5px"
							style={{
								display:
									documentMetadata.hasOwnProperty(item.id) &&
									documentMetadata[item.id].hasOwnProperty("keywords") &&
									documentMetadata[item.id]["keywords"] !== ""
										? "block"
										: "none",
							}}
						>
							<strong>Keywords:</strong>
							<p
								id="document_subject_div"
								dangerouslySetInnerHTML={maskHightlight(documentMetadata[item.id]["keywords"], item.idItem)}
							></p>
						</p>
					) : null}
					{documentMetadata.hasOwnProperty(item.id) && documentMetadata[item.id].hasOwnProperty("language") ? (
						<p
							className="mb-5px"
							style={{
								display:
									documentMetadata.hasOwnProperty(item.id) &&
									documentMetadata[item.id].hasOwnProperty("language") &&
									documentMetadata[item.id]["language"] !== ""
										? "block"
										: "none",
							}}
						>
							<strong>Language:</strong>
							<p
								id="document_subject_div"
								dangerouslySetInnerHTML={maskHightlight(documentMetadata[item.id]["language"], item.idItem)}
							></p>
						</p>
					) : null}
					{documentMetadata.hasOwnProperty(item.id) && documentMetadata[item.id].hasOwnProperty("title") ? (
						<p
							className="mb-5px"
							style={{
								display:
									documentMetadata.hasOwnProperty(item.id) &&
									documentMetadata[item.id].hasOwnProperty("title") &&
									documentMetadata[item.id]["title"] !== ""
										? "block"
										: "none",
							}}
						>
							<strong>Title:</strong>
							<p
								id="document_subject_div"
								dangerouslySetInnerHTML={maskHightlight(documentMetadata[item.id]["title"], item.idItem)}
							></p>
						</p>
					) : null}
					{documentMetadata.hasOwnProperty(item.id) && documentMetadata[item.id].hasOwnProperty("author") ? (
						<p
							className="mb-5px"
							style={{
								display:
									documentMetadata.hasOwnProperty(item.id) &&
									documentMetadata[item.id].hasOwnProperty("author") &&
									documentMetadata[item.id]["version"] !== ""
										? "block"
										: "none",
							}}
						>
							<strong>Version:</strong>
							<p
								id="document_subject_div"
								dangerouslySetInnerHTML={maskHightlight(documentMetadata[item.id]["version"], item.idItem)}
							></p>
						</p>
					) : null}

					<p className="mb-5px">
						<strong>Content:</strong>{" "}
					</p>
				</Fragment>
			)

			break
		case "pdf":
			return (
				<Fragment>
					<p className="mb-5px">
						<strong>Type:</strong>
						<span dangerouslySetInnerHTML={operationsHelper.getDocumentType(item.source)}></span>
					</p>
					<p className="mb-5px">
						<strong>Author:</strong>
						<p
							id="document_subject_div"
							dangerouslySetInnerHTML={
								documentMetadata.hasOwnProperty(item.id) && documentMetadata[item.id].hasOwnProperty("author")
									? maskHightlight(documentMetadata[item.id]["author"], item.id)
									: {
											__html: `
                                                                <div className="col-12 d-flex justify-content-center mt-5 mb-5">
                                                                    <div className="d-flex align-items-center alert alert-warning">
                                                                        <strong className="loading">Loading...</strong>
                                                                        <div className="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                                                                    </div>
                                                                </div>
                                                                `,
									  }
							}
						></p>
					</p>

					<p className="mb-5px">
						<strong>File name:</strong>
						<p
							id="document_from_div"
							dangerouslySetInnerHTML={
								documentMetadata.hasOwnProperty(item.id) && documentMetadata[item.id].hasOwnProperty("filename")
									? maskHightlight(documentMetadata[item.id]["filename"], item.id)
									: {
											__html: `
                                                                <div className="col-12 d-flex justify-content-center mt-5 mb-5">
                                                                    <div className="d-flex align-items-center alert alert-warning">
                                                                        <strong className="loading">Loading...</strong>
                                                                        <div className="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                                                                    </div>
                                                                </div>
                                                                `,
									  }
							}
						></p>
					</p>

					<p className="mb-5px">
						<strong>File path:</strong>
						<p
							id="document_to_div"
							dangerouslySetInnerHTML={
								documentMetadata.hasOwnProperty(item.id) && documentMetadata[item.id].hasOwnProperty("filepath")
									? maskHightlight(documentMetadata[item.id]["filepath"], item.id)
									: {
											__html: `
                                                                <div className="col-12 d-flex justify-content-center mt-5 mb-5">
                                                                    <div className="d-flex align-items-center alert alert-warning">
                                                                        <strong className="loading">Loading...</strong>
                                                                        <div className="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                                                                    </div>
                                                                </div>
                                                                `,
									  }
							}
						></p>
					</p>

					<p className="mb-5px">
						<strong>Date:</strong>{" "}
						<span>
							{documentMetadata.hasOwnProperty(item.id) && documentMetadata[item.id].hasOwnProperty("date")
								? // new Intl.DateTimeFormat('en-US', {
								  //     year: 'numeric',
								  //     month: 'long',
								  //     day: '2-digit'
								  // }).format(documentMetadata[item.id]['date'])

								  new Date(documentMetadata[item.id]["date"]).toLocaleString("en-US", {
										year: "numeric",
										month: "long",
										day: "2-digit",
								  })
								: ""}
						</span>
					</p>

					<p className="mb-5px">
						<strong>Content:</strong>{" "}
					</p>
				</Fragment>
			)

			break
		default:
			return ""
	}
}

export default MetadataLayoutDetails
